import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';
import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';

import CustomReports from './CustomReports.vue';
import RoundRobinDashboard from './RoundRobinDashboard.vue';

// Painel de Gestão Operacional: 6 seções + charts. Lazy pra não entrar no
// bundle de quem só abre os relatórios antigos.
const OperationsDashboard = () => import('./OperationsDashboard.vue');
// Leads de anúncio (Click-to-WhatsApp/Messenger/Instagram). Lazy pelo mesmo
// motivo.
const AdLeadsReport = () => import('./AdLeadsReport.vue');
const MetaCostsReport = () => import('./MetaCostsReport.vue');
const PauseReport = () => import('./PauseReport.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        {
          path: 'gestao',
          name: 'account_operations_reports',
          meta,
          component: OperationsDashboard,
        },
        {
          path: 'ad_leads',
          name: 'ad_leads_reports',
          meta,
          component: AdLeadsReport,
        },
        {
          path: 'meta_costs',
          name: 'meta_costs_reports',
          meta,
          component: MetaCostsReport,
        },
        {
          // Relatório único de pausas (atendimento + ligações). Abre também
          // pras permissões que viam a cópia de cada seção de telefonia.
          path: 'pauses',
          name: 'pause_reports',
          meta: {
            ...meta,
            permissions: [
              ...meta.permissions,
              'telephony_reports_access',
              'whatsapp_voice_reports_access',
            ],
          },
          component: PauseReport,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        {
          path: 'custom',
          name: 'custom_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: CustomReports,
        },
        {
          path: 'round-robin',
          name: 'round_robin_dashboard',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: RoundRobinDashboard,
        },
      ],
    },
  ],
};
